import config from "config";
import { APICore } from "helpers/api/apiCore";
import { FilterMetadata } from "redux/types";

const api = new APICore();

function fetchCoLenderFinanciersApi(params: FilterMetadata) {
    const baseUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers`;
    return api.get(`${baseUrl}`, params);
}

function fetchCoLenderFinancierByIdApi(params: any) {
    const baseUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers/${params}`;
    return api.get(`${baseUrl}`, params);
}

function createCoLenderFinancierApi(params: any) {
    let backendApiUrl = "";
    let apiData: any = {
        name: params.name ? params.name.trim() : "",
        taxIdentifier: params.taxIdentifier ? params.taxIdentifier.trim() : "",
        taxIdentifierType: params.taxIdentifierType ? params.taxIdentifierType.trim() : "",
        colenderSharePct: params.colenderSharePct !== "" && params.colenderSharePct !== undefined ? Number(params.colenderSharePct) : null,
    }
    if (!params.draft) {
        apiData.makerRemarks = params.makerRemarks ? params.makerRemarks.trim() : "";
        backendApiUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers`;
    } else {
        backendApiUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers?draft=${params.draft}`;
    }
    const baseUrl = backendApiUrl;
    return api.create(`${baseUrl}`, apiData);
}

function updateCoLenderFinancierApi(params: any) {
    let backendApiUrl = "";
    let apiData: any = {
        name: params.name ? params.name.trim() : "",
        taxIdentifier: params.taxIdentifier ? params.taxIdentifier.trim() : "",
        taxIdentifierType: params.taxIdentifierType ? params.taxIdentifierType.trim() : "",
        colenderSharePct: params.colenderSharePct !== "" && params.colenderSharePct !== undefined ? Number(params.colenderSharePct) : null,
    }
    if (!params.draft) {
        apiData.makerRemarks = params.makerRemarks ? params.makerRemarks.trim() : "";
        backendApiUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers/${params.externalId}`;
    } else {
        backendApiUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers/${params.externalId}?draft=${params.draft}`;
    }
    const baseUrl = backendApiUrl;
    return api.update(`${baseUrl}`, apiData);
}

function fetchCoLenderFinancierVersionsApi(params: any) {
    const baseUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers/${params}/versions`;
    return api.get(`${baseUrl}`, params);
}

function fetchCoLenderFinancierVersionDetailsApi(params: any) {
    const baseUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers/${params?.externalID}/versions/${params?.internalID}`;
    return api.get(`${baseUrl}`, {});
}

function fetchCoLenderFinancierLatestVersionApi(params: any) {
    let flag = {
        modifyLatest: params?.status === "New" ? false : true
    }
    const baseUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers/${params?.externalId}/latestVersion`;
    return api.get(`${baseUrl}`, flag);
}

function deleteCoLenderFinancierApi(params: any) {
    const baseUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers/${params}`;
    return api.delete(`${baseUrl}`);
}

function approveCoLenderFinancierApi(params: any) {
    let remarks = {
        checkerRemarks: params.checkerRemarks.trim()
    };
    let externalId = params.externalId;
    const baseUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers/${externalId}/approve`;
    return api.updatePatch(`${baseUrl}`, remarks)
}

function rejectCoLenderFinancierApi(params: any) {
    let remarks = {
        checkerRemarks: params.checkerRemarks.trim()
    };
    let externalId = params.externalId;
    const baseUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers/${externalId}/reject`;
    return api.updatePatch(`${baseUrl}`, remarks)
}

function blockCoLenderFinancierApi(params: any) {
    const param = {
        inactiveReason: params.inactiveReason.trim()
    };
    const baseUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers/${params.id}/block`;
    return api.updatePatch(`${baseUrl}`, param);
}

function freezeCoLenderFinancierApi(params: any) {
    const param = {
        inactiveReason: params.inactiveReason.trim()
    };
    const baseUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers/${params.id}/freeze`;
    return api.updatePatch(`${baseUrl}`, param);
}

function unfreezeCoLenderFinancierApi(params: any) {
    const param = {
        inactiveReason: params.inactiveReason.trim()
    };
    const baseUrl = `${config.BACKEND_BASE_URL}/co-lender-financiers/${params.id}/unfreeze`;
    return api.updatePatch(`${baseUrl}`, param);
}

export {
    fetchCoLenderFinanciersApi,
    fetchCoLenderFinancierByIdApi,
    createCoLenderFinancierApi,
    updateCoLenderFinancierApi,
    fetchCoLenderFinancierVersionsApi,
    deleteCoLenderFinancierApi,
    approveCoLenderFinancierApi,
    rejectCoLenderFinancierApi,
    blockCoLenderFinancierApi,
    freezeCoLenderFinancierApi,
    unfreezeCoLenderFinancierApi,
    fetchCoLenderFinancierVersionDetailsApi,
    fetchCoLenderFinancierLatestVersionApi
}